import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';

// Import all page components
import Homepage from './pages/homepage';
import About from './pages/about';
import Services from './pages/services/index.jsx';
import Portfolio from './pages/testimonials';
import Contact from './pages/contact';
import Booking from './pages/booking';
import PrivacyPolicy from './pages/privacy-policy';
import TermsOfService from './pages/terms';
import DataDeletionStatus from './pages/data-deletion-status';

import SpecialistBooking from "pages/specialist-booking";

import TreatmentsList from './pages/treatments/TreatmentsList';

import Login from './pages/auth/Login';
//import MultiStepBookingSystem from './pages/multi-step-booking-system-bak';
import AdminAppointmentDashboard from './pages/admin/admin-appointment-dashboard';
import WhatsAppIntegrationHub from './pages/admin/whats-app-integration-hub';
import NotFound from './pages/NotFound';
//import TherapistManagementDashboard from './pages/therapist-management-dashboard';
import StaffManagementDashboard from './pages/admin/staff-management-dashboard';
//import GenderBasedBookingFlow from './pages/gender-based-booking-flow-bak';
//import ServiceTreatmentManagementCenter from './pages/service-treatment-management-center-bak';
import TreatmentPage from "./pages/treatments/TreatmentPage";
import TreatmentAssessment from "./pages/treatments/:slug/assessment";
import DiscountManagement from './pages/admin/discount-management-dashboard';
//import TestPricing from './pages/test-pricing';
import QuickDiscountCreator from './pages/admin/quick-discount-creator';

export default function Routes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Main Routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/testimonials" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/specialist-booking" element={<SpecialistBooking />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/data-deletion-status" element={<DataDeletionStatus />} />

          {/* ============================================================
              REDIRECT OLD TREATMENT CENTER URLS TO NEW DYNAMIC ROUTES
              ============================================================ */}
          {/* Redirect old static URLs to new unified dynamic treatment pages */}
          <Route path="/psoriasis-treatment-center" element={<Navigate to="/treatments/psoriasis-treatment" replace />} />
          <Route path="/pcod-pcos-treatment-center" element={<Navigate to="/treatments/pcod-pcos-treatment" replace />} />
          <Route path="/avn-treatment-center" element={<Navigate to="/treatments/avn-treatment" replace />} />
          <Route path="/spinal-problems-treatment-center" element={<Navigate to="/treatments/spinal-problems-treatment" replace />} />
          <Route path="/gout-treatment-center" element={<Navigate to="/treatments/gout-treatment" replace />} />
          <Route path="/rheumatoid-arthritis-treatment-center" element={<Navigate to="/treatments/rheumatoid-arthritis-treatment" replace />} />
          <Route path="/osteoarthritis-treatment-center" element={<Navigate to="/treatments/osteoarthritis-treatment" replace />} />

          {/* ============================================================
              DYNAMIC TREATMENT ROUTES (NEW UNIFIED SYSTEM)
              ============================================================ */}
          {/* Treatment Routes */}
          <Route path="/treatments" element={<TreatmentsList />} />
          <Route path="/treatments/:slug" element={<TreatmentPage />} />

          {/* Dynamic Disease-Specific Assessment Route - Uses standardized scoringRanges structure */}
          <Route
            path="/treatments/:slug/assessment"
            element={<TreatmentAssessment />}
          />

          {/* Authentication Routes */}
          <Route path="/login" element={<Login />} />

          {/* Booking and Dashboard Routes */}
          {/* <Route path="/multi-step-booking-system" element={<MultiStepBookingSystem />} /> */}
          <Route path="/admin-appointment-dashboard" element={<AdminAppointmentDashboard />} />

          {/* WhatsApp Integration Hub */}
          <Route path="/whats-app-integration-hub" element={<WhatsAppIntegrationHub />} />

          {/* Management Dashboards */}
          {/* <Route path="/therapist-management-dashboard" element={<TherapistManagementDashboard />} /> */}
          <Route path="/staff-management-dashboard" element={<StaffManagementDashboard />} />
          {/* <Route path="/gender-based-booking-flow" element={<GenderBasedBookingFlow />} /> */}
          {/* <Route path="/service-treatment-management-center" element={<ServiceTreatmentManagementCenter />} /> */}
          <Route path="/discount-management-dashboard" element={<DiscountManagement />} />
          {/* <Route path="/test-pricing" element={<TestPricing />} /> */}
          <Route path="/quick-discount-creator" element={<QuickDiscountCreator />} />

          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}